var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHeroArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 120,
    viewBox: "0 0 16 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9 1C9 0.447715 8.55228 2.41411e-08 8 0C7.44772 -2.41411e-08 7 0.447715 7 1L9 1ZM7.29289 119.707C7.68341 120.098 8.31658 120.098 8.7071 119.707L15.0711 113.343C15.4616 112.953 15.4616 112.319 15.0711 111.929C14.6805 111.538 14.0474 111.538 13.6568 111.929L7.99999 117.586L2.34314 111.929C1.95262 111.538 1.31945 111.538 0.928927 111.929C0.538403 112.319 0.538403 112.953 0.928927 113.343L7.29289 119.707ZM7 1L6.99999 119L8.99999 119L9 1L7 1Z",
    fill: "#222222"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeroArrow);
export default __webpack_public_path__ + "static/media/hero-arrow.1ab1ea492ac4253e75ab61491a21ed2f.svg";
export { ForwardRef as ReactComponent };